import {compose} from 'redux';
import {connect} from 'react-redux';
import {findDOMNode} from 'react-dom';
import {createElement, propTypes, PropTypes, Component} from 'rlink-react';
import showTooltip from 'rlink-tooltips/actions/showTooltip';
import hideTooltip from 'rlink-tooltips/actions/hideTooltip';
import {deepEquals} from 'rlink-utils/object';

const TOOLTIP_OPEN_DELAY = 100;

export default compose(
  propTypes({
    content: PropTypes.node,
    children: PropTypes.element,
    onChildMounted: PropTypes.func,
    hideTooltip: PropTypes.func,
  }),
  connect(null, (dispatch, {content}) => ({
    onChildMounted (element) {
      element.addEventListener('mouseenter', () => {
        clearTimeout(element.dataset._showDelay);

        element.dataset._showDelay = setTimeout(() => {
          element.dataset._tooltipWasShown = true;
          dispatch(showTooltip({content}))
        },
          TOOLTIP_OPEN_DELAY
        );
      });
      element.addEventListener('mouseleave', () => {
        clearTimeout(element.dataset._showDelay);
        if (element.dataset._tooltipWasShown) {
          dispatch(hideTooltip());
          element.dataset._tooltipWasShown = false;
        }
      });
    },
    hideTooltip () {
      dispatch(hideTooltip());
    },
  }))
)(class Tooltip extends Component {
  componentDidMount () {
    this._mountedDomNode = findDOMNode(this);
    this.props.onChildMounted(this._mountedDomNode);
  }
  componentDidUpdate (prevProps) {
    let mountedDomNode = findDOMNode(this);
    if (!(deepEquals(prevProps.content, this.props.content))
      || this._mountedDomNode !== mountedDomNode) {
      this._mountedDomNode = mountedDomNode;
      this.props.onChildMounted(this._mountedDomNode);
    }
  }
  componentWillUnmount () {
    this.props.hideTooltip();
  }
  render () {
    return this.props.children;
  }
});



// WEBPACK FOOTER //
// ./lib/rlink-tooltips/Tooltip.jsx